import React from "react";
import { useIntl } from "react-intl";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";

import { PaginationWrapper, TotalText, StyledPagination } from "./styles";

const itemRender = (page, type, originalElement) => {
  if (type === "prev") return <RiArrowLeftSLine size={16} />;
  if (type === "next") return <RiArrowRightSLine size={16} />;
  return originalElement;
};

const Pagination = ({
  current = 1,
  pageSize = 10,
  total = 0,
  onChange = () => {},
  showTotal = true,
  ...props
}) => {
  const intl = useIntl();

  if (total <= pageSize) return null;

  const from = (current - 1) * pageSize + 1;
  const to = Math.min(current * pageSize, total);

  return (
    <PaginationWrapper>
      {showTotal && (
        <TotalText>
          {intl.formatMessage({ id: "displaying" })} {from} - {to}{" "}
          {intl.formatMessage({ id: "of" })} {total}
        </TotalText>
      )}
      <StyledPagination
        current={current}
        pageSize={pageSize}
        total={total}
        onChange={onChange}
        itemRender={itemRender}
        showSizeChanger={false}
        {...props}
      />
    </PaginationWrapper>
  );
};

export default Pagination;
